import React from 'react';

interface DetailModel {
  count: number;
  text: string;
}

interface DetailsContainerProps {
  itemIndex: number;
  data: DetailModel[];
  productID: number;
  itemTotalCount: number;
  update: () => void;
}

interface DetailsContainerState {
  data: DetailModel[];
  asynchron: boolean;
}

export default class DetailsContainer extends React.Component<
  DetailsContainerProps,
  DetailsContainerState
> {
  constructor(props: DetailsContainerProps) {
    super(props);
    this.state = { data: props.data, asynchron: false };
  }

  addNewItem() {
    let localSum =
      this.state.data ?? [].reduce((sum, current) => +sum + +current.count, 0);

    let newState = this.state.data ?? [];

    let newItem = { count: this.props.itemTotalCount - localSum, text: '' };
    newState.push(newItem);

    this.setState({ data: newState, asynchron: true });
  }

  render(): React.ReactNode {
    let localSum = 0;
    if (this.state.data != undefined)
      localSum = this.state.data.reduce(
        (sum, current) => +sum + +current.count,
        0,
      );

    let addButton: JSX.Element | null = null;

    if (localSum < this.props.itemTotalCount) {
      addButton = (
        <button
          onClick={(event) => {
            event.preventDefault();
            this.addNewItem();
          }}
        >
          Referenz hinzufügen
        </button>
      );
    }

    return (
      <div
        className="DetailsContainer"
        id={'DetailsContainer_' + this.props.itemIndex}
      >
        {this.state.data != null && this.state.data.length > 0 ? (
          <table>
            <thead>
              <tr>
                <th>Anzahl</th>
                <th>Referenz</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {this.state.data.map((item, index) => {
                return (
                  <tr key={'itemTable_' + this.props.itemIndex + '_' + index}>
                    <td>
                      <input
                        type="number"
                        name={
                          'productDetInfo__' +
                          this.props.productID +
                          '_' +
                          index +
                          '_count'
                        }
                        defaultValue={item.count}
                        onChange={(event2) => {
                          this.setState({ asynchron: true });
                        }}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        name={
                          'productDetInfo_' +
                          this.props.productID +
                          '_' +
                          index +
                          '_text'
                        }
                        onChange={() => {
                          this.setState({ asynchron: true });
                        }}
                        defaultValue={item.text}
                      />
                    </td>
                    {index == 0 && this.state.asynchron ? (
                      <td rowSpan={this.state.data.length}>
                        <button>Speichern</button>
                      </td>
                    ) : null}
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : null}
        {addButton}
      </div>
    );
  }
}
